import React from 'react';
import { FiAlertCircle } from 'react-icons/fi';

export default function ModalRestaurar(props) {
    return (
        <div className="modal-fundo">
            <div className="modal2">
                <div className="modal-titulo">
                    <FiAlertCircle size={88} />
                    <p>O CONSUMO SERÁ REDISTRIBUÍDO!</p>
                </div>
                <div className="modal-conteudo">
                    <p>
                        Ao restaurar a curva, a média de consumo será preservada, mas o
                        consumo será redistribuido entre os meses.
                    </p>
                    <br/>
                    <p>
                        Deseja proseguir com essa ação?
                    </p>
                    <br/>
                </div>
                <div className="modal-acao">
                    <button className="modal-botao" onClick={(e) => props.setModalRestaurarAberto(false)}>
                        Cancelar
                    </button>
                    <button className="modal-botao" onClick={(e) => {props.restaurar_curva_consumo(); props.setModalRestaurarAberto(false);}}>
                        Proseguir
                    </button>
                </div>
            </div>
        </div>
    );
}